import { gql } from '@apollo/client'

export const processGrantsForZumrails = gql`
  mutation processGrantsForZumrails($grantIds: [Int!]!) {
    processGrantsForZumrails(grantIds: $grantIds) {
      grantId
      transactionId
      success
      amount
      errorReason
      charityAccountName
    }
  }
`

export const reissueGrant = gql`
  mutation reissueGrant($data: ReissueGrantInput!) {
    reissueGrant(data: $data) {
      id
      reissuedAmount
      deductionAmount
      charityId
    }
  }
`

export const processNQDGrant = gql`
  mutation processNQDGrant($data: ProcessNQDGrantInput!) {
    processNQDGrant(data: $data) {
      id
      deductionAmount
      charityId
    }
  }
`

export const updateGrantDeduction = gql`
  mutation updateGrantDeduction($data: UpdateGrantDeductionInput!) {
    updateGrantDeduction(data: $data) {
      id
      deductionAmount
    }
  }
`
